module.exports = __webpack_public_path__ + "img/background-inconclusive.e55e1380.svg";